import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import Button from './Button'
import InViewMonitor from 'react-inview-monitor'
import EnterpriseContactModal from './EnterpriseContactModal'

import { showModal } from '../../reducers/modal'

import { trackEvent } from '../../utils/tracking'

import { MAKERS_URL } from '../../config/'

const GenericCtaModule = ({
  className,
  imageUrl,
  headerTitle,
  subtitle,
  buttonLabel,
  buttonClass = 'button--primary',
  buttonHref,
  buttonOnClick,
  buttonForceAnchorElement,
  secondaryEnterpriseButton,
  showModal
}) => (
  <div className={className + ' md-flex items-center'}>
    <InViewMonitor
      classNameNotInView='md-col-5 vis-hidden'
      classNameInView='md-col-5 animated fadeInUp'
    >
      <div className='center mb2'>
        <img src={imageUrl} style={{ maxHeight: '300px' }} />
      </div>
    </InViewMonitor>
    <div className='col-10 mx-auto md-col-7 md-center'>
      <div className='mb3'>
        <h3 className='h3 mb1'>{headerTitle}</h3>
        {subtitle && <div className='grey'>{subtitle}</div>}
      </div>

      <Button
        className={classnames(
          buttonClass,
          'generic-cta-module__button button button--large'
        )}
        href={buttonHref}
        onClick={buttonOnClick}
        forceAnchorElement={buttonForceAnchorElement}
      >
        {buttonLabel}
      </Button>

      {secondaryEnterpriseButton && (
        <Button
          className='generic-cta-module__button generic-cta-module__button--second button button--secondary button--large'
          onClick={() => {
            trackEvent('EnterpriseContactModal', 'GenericCtaModule')
            showModal(<EnterpriseContactModal />)
          }}
        >
          Contact our enterprise team
        </Button>
      )}
    </div>
  </div>
)

GenericCtaModule.propTypes = {
  className: PropTypes.string,
  headerTitle: PropTypes.string,
  subTitle: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonHref: PropTypes.string,
  buttonOnClick: PropTypes.func,
  buttonForceAnchorElement: PropTypes.bool,
  secondaryEnterpriseButton: PropTypes.bool
}

GenericCtaModule.defaultProps = {
  className: '',
  buttonHref: MAKERS_URL,
  headerTitle: 'Ready to build your voice assistant?',
  imageUrl: '/static/images/birdwatcher_white.gif',
  buttonLabel: 'Start Building for Free',
  buttonForceAnchorElement: true,
  secondaryEnterpriseButton: true
}

export default connect(null, { showModal })(GenericCtaModule)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/GenericCtaModule.js